import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { CheckBox, ColunmCheck, TabPanelRow } from './styles';

function CheckRow({ dados, onChecked, selecoes }) {
    const handleCheckboxChange = (item, itemSelect) => {
        onChecked(item, itemSelect.checked, itemSelect.id);
    }

    return ( 
        <>
            {dados.map((item) => (
                <> 
                    <CheckRow dados={item.subNav} onChecked={onChecked} selecoes={selecoes} />
                    {item.subNav.length > 0 
                        ? ""
                        : <TabPanelRow md="12">
                            <Col md="4">
                                <Form.Label>{item.title}</Form.Label>
                            </Col>
                            
                            {item.actions.map( (actions) => {
                                const cIdentificador = item.indice+'-'+item.title+'-'+actions;
                                return <ColunmCheck md="2" >
                                    <CheckBox
                                        id={cIdentificador}
                                        type="checkbox"
                                        label={actions}
                                        checked={selecoes[cIdentificador] || false}
                                        onChange={(e) => handleCheckboxChange(item, e.target)}
                                        disabled={item.subNav && item.subNav.length > 0}
                                    />
                                </ColunmCheck>
                            })}
                        </TabPanelRow>
                    }
                </>
            ))}
        </>
    );
}

export default CheckRow;
